import { render, staticRenderFns } from "./NicsTable.vue?vue&type=template&id=0ada4954&"
import script from "./NicsTable.vue?vue&type=script&lang=js&"
export * from "./NicsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports